import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="4 2 16 20"
    fill="#0000FE"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g>
      <path d="M18,22H6a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2h7.1a2,2,0,0,1,1.5.6l4.9,5.2A2,2,0,0,1,20,9.2V20A2,2,0,0,1,18,22Z" />
      <line stroke="white" fill="none" x1="7.9" x2="16.1" y1="17.5" y2="17.5" />
      <line stroke="white" fill="none" x1="7.9" x2="16.1" y1="13.5" y2="13.5" />
      <line stroke="white" fill="none" x1="8" x2="13" y1="9.5" y2="9.5" />
    </g>
  </svg>
);
